export type SelectOption = {
  label: string;
  value: string;
};

// Opções partilhadas pelo formulário e pela grid.
// O "value" (em inglês) é o que vai para o backend na pesquisa;
// o "label" é o único texto que o utilizador deve ver.
/**
 * Tipos de emprego. 
 */
export const jobTypeOptions: SelectOption[] = [
  { label: "Tempo Integral", value: "full time" },
  { label: "Tempo Parcial", value: "part time" },
  { label: "Contrato", value: "contract" },
  { label: "Temporário", value: "temporary" },
  { label: "Voluntário", value: "volunteer" },
  { label: "Estágio", value: "internship" },
];

export const jobTypeOptionsCards: SelectOption[] = [
  { label: "Tempo Integral", value: "Tempo Integral" },
  { label: "Tempo Parcial", value: "Tempo Parcial" },
  { label: "Contrato", value: "Contrato" },
  { label: "Temporário", value: "Temporário" },
  { label: "Voluntário", value: "Voluntário" },
  { label: "Estágio", value: "Estágio" },
];

/**
 * Níveis de experiência. 
 */
export const experienceLevelOptions: SelectOption[] = [
  { label: "Estagiário", value: "internship" },
  { label: "Nível de entrada (Júnior)", value: "entry level" },
  { label: "Associado", value: "associate" },
  { label: "Sênior", value: "senior" },
  { label: "Diretor", value: "director" },
  { label: "Executivo", value: "executive" },
];
/**
 * Regime de trabalho. 
 */
export const regimeTypeOptions: SelectOption[] = [
  { label: "Presencial", value: "on site" },
  { label: "Remoto", value: "remote" },
  { label: "Híbrido", value: "hybrid" },
];

/**
 * Converte o "value" guardado de volta na "label" para apresentação
 * (modo de visualização, colunas da grid). Se não encontrar, devolve o valor.
 */
export const getOptionLabel = (
  options: SelectOption[],
  value: string | null | undefined
): string =>
  options.find((option) => option.value === value)
    ?.label ??
  value ??
  "";

export type RangeUnit = "hour" | "day" | "week" | "month";

export const rangeUnitOptions: SelectOption[] = [
  { label: "Horas", value: "hour" },
  { label: "Dias", value: "day" },
  { label: "Semanas", value: "week" },
  { label: "Meses", value: "month" },
];

export type RangePreset = { label: string; value: number; unit: RangeUnit };
export const rangePostedPresets: RangePreset[] = [
  { label: "24h", value: 24, unit: "hour" },
  { label: "72h", value: 72, unit: "hour" },
  { label: "1 semana", value: 1, unit: "week" },
  { label: "2 semanas", value: 2, unit: "week" },
  { label: "1 mês", value: 1, unit: "month" },
];

export const rangePostedOptions: SelectOption[] = rangePostedPresets.map((p) => ({
  label: p.label,
  value: `${p.value} ${p.unit}`,
}));

export const buildRangePosted = (
  value: number | null | undefined,
  unit: string | null | undefined
): string => (value && value > 0 && unit ? `${value} ${unit}` : "");

export const parseRangePosted = (
  rangePosted: string | null | undefined
): { value: number | null; unit: string } => {
  if (!rangePosted) return { value: null, unit: "" };
  const [rawValue, rawUnit] = rangePosted.trim().split(/\s+/);
  const parsed = Number(rawValue);
  return { value: Number.isNaN(parsed) ? null : parsed, unit: rawUnit ?? "" };
};

export const formatRangePostedLabel = (
  rangePosted: string | null | undefined
): string => {
  const { value, unit } = parseRangePosted(rangePosted);
  if (!value || !unit) return rangePosted ?? "";
  return `${value} ${getOptionLabel(rangeUnitOptions, unit)}`;
};
